<template>
  <div>
    <!-- Loader -->
    <div v-if="isLoading" class="global-loader">
      <div class="loader-icon"></div>
      <p>Loading data, please wait...</p>
    </div>

    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { loadAllAgents } from "./utils/userInfo.js";

export default {
  data() {
    return {
      isLoading: true,
    };
  },
  async mounted() {
    try {
      await loadAllAgents();
    } catch (error) {
    } finally {
      this.isLoading = false; // Hide loader
    }
  },
};
</script>

<style scoped>
.global-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-size: 18px;
  color: #555;
}

.loader-icon {
  width: 40px;
  height: 40px;
  border: 5px solid #ccc;
  border-top-color: #42b983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
